import { Eyebrow, Reveal } from "./Reveal";

const SKILL_GROUPS = [
  {
    title: "Business Analysis",
    skills: [
      "Requirements Engineering",
      "BRD",
      "Functional Requirements",
      "Process Analysis",
      "Business Rules",
      "Stakeholder Analysis",
    ],
  },
  {
    title: "Product",
    skills: [
      "Product Strategy",
      "Product Requirements",
      "PRD",
      "User Journeys",
      "Product Backlog",
      "Product Ownership",
    ],
  },
  {
    title: "Agile",
    skills: [
      "Agile",
      "Scrum",
      "User Stories",
      "Acceptance Criteria",
      "UAT",
      "Sprint Planning",
    ],
  },
  {
    title: "Tools & Technology",
    skills: ["Jira", "SQL", "Power BI", "Excel", "Python", "Agile Documentation"],
  },
];

export default function Skills() {
  return (
    <section
      id="skills"
      data-testid="skills-section"
      className="scroll-mt-24 py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal>
          <Eyebrow>Skills</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-display text-4xl font-semibold leading-[1.15] tracking-tight md:text-5xl">
            Capability across the product lifecycle
          </h2>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {SKILL_GROUPS.map((group, i) => (
            <Reveal key={group.title} delay={i * 0.06}>
              <div data-testid={`skill-group-${i}`}>
                <h3 className="flex items-center gap-3 text-xs font-medium uppercase tracking-[0.2em] text-navy/60">
                  <span className="h-1.5 w-1.5 bg-rust" aria-hidden="true" />
                  {group.title}
                </h3>
                <ul className="mt-5 flex flex-wrap gap-2">
                  {group.skills.map((skill) => (
                    <li
                      key={skill}
                      className="rounded-full border border-navy/15 bg-white px-3.5 py-1.5 text-sm text-navy/80 transition-colors duration-300 hover:border-rust/50"
                    >
                      {skill}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
